import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { buttonVariants } from './buttonVariants';

import { cn } from '@/lib/utils';

function Button({
  asChild = false,
  className,
  size = 'default',
  variant,
  ...props
}: {
  asChild?: boolean;
} & React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants>) {
  const Comp = asChild ? Slot : 'button';

  const resolvedVariant =
    variant === undefined || variant === 'default'
      ? location.pathname.startsWith('/firm/chatbot')
        ? 'default'
        : 'smc-blue'
      : variant;

  return (
    <Comp
      className={cn(
        buttonVariants({ className, size, variant: resolvedVariant }),
        'cursor-pointer'
      )}
      data-size={size}
      data-slot="button"
      data-variant={resolvedVariant}
      {...props}
    />
  );
}

export { Button };
